import React, { useState, useEffect } from "react";
import type { TableData } from "../../../components/Table/AuditLogTable";
import { Search } from "lucide-react";
import ExportPrintActions from "../../../utils/exportUtils";

interface AuditLogFilterProps {
  logs: TableData[];
  onFilter: (data: TableData[]) => void;
}

export default function AuditLogFilter({ logs, onFilter }: AuditLogFilterProps) {
  const [search, setSearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [filteredData, setFilteredData] = useState<TableData[]>(logs);

  useEffect(() => {
    const q = appliedSearch.trim().toLowerCase();
    const filtered = logs.filter((log) => {
      if (!q) return true;
      return (
        (log.user || "").toLowerCase().includes(q) ||
        (log.module || "").toLowerCase().includes(q) ||
        (log.event || "").toLowerCase().includes(q)
      );
    });

    setFilteredData(filtered);
    onFilter(filtered);
  }, [appliedSearch, logs, onFilter]);

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === "Enter") setAppliedSearch(search);
  };

  // prepare columns for export/print
  const columns = filteredData[0]
    ? Object.keys(filteredData[0]).map((key) => ({
      key,
      label: key,
    }))
    : [];

  return (

    <div className="space-y-4">
      <div className="mt-3 md:mt-0 no-print flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        {/* search input */}
        <div className="relative w-full md:w-[40%]">
          <Search
            className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-400"
            size={18}
          />
          <input
            type="text"
            value={search}
            onChange={handleChangeSearch}
            onKeyDown={handleKeyDown}
            placeholder="Search for name, module or event..."
            className="border p-3 pl-10 rounded-full w-full lg:w-[70%] bg-white focus:outline-none focus:ring-2 focus:ring-[#B9C3DB]"
          />
        </div>

        {/* export and print buttons */}
        <div className="flex justify-end w-full md:w-auto mt-3 md:mt-0">
          <ExportPrintActions
            rows={filteredData}
            columns={columns}
            fileName="audit_logs"
          />
        </div>
      </div>
    </div>



  );
}



